export const UI_BUILD_VERSION = '2.5.5';
